import { Jackpot } from '../models/jackpot.interface';

import { ApiService } from './';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';

@Injectable()
export class CagnotteService {

  constructor(private apiService: ApiService) { }

  findById(id: number): Observable<Jackpot> {
    return this.apiService.get('/gandadmin/cagnottes/' + id);
  }

  list(params: DataTableParams): Observable<any> {
    params.offset = params.offset / params.limit
    return this.apiService.post('/gandadmin/cagnottes', params);
  }

  saveOrUpdate(input: Jackpot): Observable<Jackpot> {
    return this.apiService.put('/gandadmin/cagnottes/' + input.id, { charity_pot: input });
  }

  activateOrDeactivateCharityPot(jackpot: Jackpot): Observable<Jackpot> {
    const verb = jackpot.is_active ? 'deactivate' : 'activate';
    return this.apiService.post('/gandadmin/cagnottes/' + jackpot.id + '/' + verb)
  }
}
